import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Grid, Button } from 'semantic-ui-react';

import { LoadingBar, Pagination, TableForm } from 'components/Commons';

import cm from 'helpers/commons';

class UserSikdaeGivenModal extends Component {
  render() {
    const { sikDetail } = this.props;
    const { modal, closeModal, pageClickModal, downloadExcel, isLoading } = this.props.modalFn;
    let loading = '',
      content = '';

    if (sikDetail) {
      if (sikDetail.data) {
        const { paging, total, info, point } = sikDetail.data,
          tabledata = {
            header: {
              main: [
                { data: '날짜', textAlign: 'left' },
                { data: '결제번호', textAlign: 'left' },
                { data: '구분', textAlign: 'left' },
                { data: '식대그룹', textAlign: 'left' },
                { data: '식대정책', textAlign: 'left' },
                { data: '식대지급/차감', textAlign: 'right' },
                { data: '식대사용', textAlign: 'right' },
                { data: '정책별 식대잔액', textAlign: 'right' },
                { data: '사유', textAlign: 'left' }
              ],
              sub: [
                { data: '총계', textAlign: 'left', colSpan: 5 },
                { data: cm.numberComma(total.inamount), textAlign: 'right' },
                { data: cm.convertMinusNumber(total.outamount), textAlign: 'right' },
                {},
                {}
              ]
            },
            body: {
              main: point
                ? point.map((item) => {
                    let obj = {
                      row: [
                        {
                          data: cm.yyyyMMdd(new Date(item.regdate)) + ' ' + cm.hhmmss(new Date(item.regdate)),
                          textAlign: 'left'
                        },
                        {
                          data: item.roomidx,
                          textAlign: 'left'
                        },
                        {
                          data: item.status.text,
                          textAlign: 'left'
                          // fontColor : item.status.value === "EXPIRE_DATE" ? "gray" : ""
                        },
                        {
                          data: item.group.name,
                          textAlign: 'left'
                        },
                        {
                          data: item.policy.name,
                          textAlign: 'left'
                        },
                        {
                          data: item.coupon.type === 'I' ? cm.convertMinusNumber(item.coupon.amount) : '',
                          textAlign: 'right',
                          fontColor: item.coupon.amount < 0 ? 'red' : ''
                        },
                        {
                          data: item.coupon.type === 'O' ? cm.convertMinusNumber(item.coupon.amount) : '',
                          textAlign: 'right',
                          fontColor:
                            item.coupon.amount < 0 ? (item.status.value === 'EXPIRE_DATE' ? 'gray' : 'red') : '',
                          textDecoration: item.status.value === 'EXPIRE_DATE' ? 'line-through' : null
                        },
                        {
                          data: cm.numberComma(item.coupon.balance),
                          textAlign: 'right'
                        },
                        {
                          data: item.cause,
                          textAlign: 'left'
                        }
                      ]
                    };
                    return obj;
                  })
                : null
            },
            footer: {
              page: paging.page,
              pagerow: paging.pagerow,
              pageblock: 10,
              totalcount: paging.totalcount,
              pageClick: pageClickModal
            }
          };

        let division = '';

        if (info && info.user) {
          division += cm.divisionCheck(1, info.user.division);
          let division2 = cm.divisionCheck(2, info.user.division);
          if (division2) {
            division += ' > ' + division2;
            let division3 = cm.divisionCheck(3, info.user.division);
            if (division3) {
              division += ' > ' + division3;
            }
          }
        }

        content = (
          <div>
            <Grid celled columns="equal" className="modal-summary">
              <Grid.Row>
                <Grid.Column width={2} className="summary-hd">
                  이름
                </Grid.Column>
                <Grid.Column>{info.user.name}</Grid.Column>
                <Grid.Column width={2} className="summary-hd">
                  조회기간
                </Grid.Column>
                <Grid.Column>
                  {cm.yyyyMMdd(new Date(info.date.startdate))} - {cm.yyyyMMdd(new Date(info.date.enddate))}
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={2} className="summary-hd">
                  식대그룹
                </Grid.Column>
                <Grid.Column> {info.user.group.name}</Grid.Column>
                <Grid.Column width={2} className="summary-hd">
                  {' '}
                  부서{' '}
                </Grid.Column>
                <Grid.Column>{cm.divisionNavi(info.user.orgCode)}</Grid.Column>
              </Grid.Row>
            </Grid>
            <div className="table-box">
              <TableForm tabledata={tabledata} />
            </div>
          </div>
        );
      } else if (sikDetail.response) {
        content = sikDetail.response.data.message;
      }
    } else {
      loading = <LoadingBar />;
    }

    return (
      <Modal className="user-sikdae-given-modal modal-large" open={modal} onClose={closeModal}>
        <Modal.Header>
          사용자 식대 상세내역
          <Button basic color="green" className="excel" onClick={downloadExcel} loading={isLoading}>
            엑셀 다운로드
          </Button>
        </Modal.Header>
        <Modal.Content>
          {loading}

          {content}
        </Modal.Content>
        <Modal.Actions>
          <Button positive content="확인" onClick={closeModal} />
        </Modal.Actions>
      </Modal>
    );
  }
}

UserSikdaeGivenModal = connect((state) => ({
  sikDetail: state.usage.userSikDetail
}))(UserSikdaeGivenModal);

export default UserSikdaeGivenModal;
